import React from "react";

import { Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import * as C from "src/organization/pages/project/environment/ConfigureResourcesPage/ConfigureResourcesPage.style";

import * as S from "./Total.style";

import type { TotalResources } from "Reducers/environment/deployment";

const Total = ({ cpu, ram, instances, disk }: Partial<TotalResources>) => {
  const intl = useIntl();

  const total = intl.formatMessage({
    id: "configure_resources.page.total",
    defaultMessage: "Total"
  });

  return (
    <>
      <S.TotalWrapper>
        <S.TotalTitle weight="semiBold" size="medium">
          {total}
        </S.TotalTitle>
        <C.IndentedBodyText weight="semiBold" size="medium" left="20px">
          {intl.formatMessage(
            {
              id: "configure_resources.page.total.quantity_type",
              defaultMessage: `${cpu} CPU`
            },
            { quantity: cpu, type: "CPU" }
          )}{" "}
          {intl.formatMessage(
            {
              id: "configure_resources.page.total.quantity_type",
              defaultMessage: `${ram} GB RAM`
            },
            { quantity: ram, type: "GB RAM" }
          )}
        </C.IndentedBodyText>
        <C.IndentedBodyText weight="semiBold" size="medium" left="20px">
          {intl.formatMessage(
            {
              id: "configure_resources.page.total.quantity.instances",
              defaultMessage: `${instances} instances`
            },
            { quantity: instances }
          )}
        </C.IndentedBodyText>
        <C.IndentedBodyText weight="semiBold" size="medium" left="20px">
          {intl.formatMessage(
            {
              id: "configure_resources.page.total.quantity_type",
              defaultMessage: `${disk} GB Disk`
            },
            { quantity: disk, type: "GB Disk" }
          )}
        </C.IndentedBodyText>
      </S.TotalWrapper>
      <S.TotalMobileWrapper>
        <Typography.BodyText size="medium" weight="semiBold">
          {total}
        </Typography.BodyText>
        <div>
          <Typography.Title tag="h3">
            {intl.formatMessage(
              {
                id: "configure_resources.page.total.quantity_type",
                defaultMessage: `${cpu} CPU`
              },
              { quantity: cpu, type: "CPU" }
            )}
          </Typography.Title>
          <S.TotalTypeLabel>
            {intl.formatMessage(
              {
                id: "configure_resources.page.total.category",
                defaultMessage: `${cpu}`
              },
              { category: "CPU" }
            )}
          </S.TotalTypeLabel>
        </div>
        <div>
          <Typography.Title tag="h3">
            {intl.formatMessage(
              {
                id: "configure_resources.page.total.quantity_type",
                defaultMessage: `${ram} GB`
              },
              { quantity: ram, type: "GB" }
            )}
          </Typography.Title>
          <S.TotalTypeLabel>
            {intl.formatMessage(
              {
                id: "configure_resources.page.total.category",
                defaultMessage: `${ram}`
              },
              { category: "RAM" }
            )}
          </S.TotalTypeLabel>
        </div>
        <div>
          <Typography.Title tag="h3">
            {intl.formatMessage(
              {
                id: "configure_resources.page.total.quantity_type",
                defaultMessage: `${instances}`
              },
              { quantity: instances, type: "" }
            )}
          </Typography.Title>
          <S.TotalTypeLabel>
            {intl.formatMessage(
              {
                id: "configure_resources.page.total.category",
                defaultMessage: `${instances}`
              },
              { category: "Instances" }
            )}
          </S.TotalTypeLabel>
        </div>
        <div>
          <Typography.Title tag="h3">
            {intl.formatMessage(
              {
                id: "configure_resources.page.total.quantity_type",
                defaultMessage: `${disk}`
              },
              { quantity: disk, type: "GB" }
            )}
          </Typography.Title>
          <S.TotalTypeLabel>
            {intl.formatMessage(
              {
                id: "configure_resources.page.total.category",
                defaultMessage: `${disk}`
              },
              { category: "Disk" }
            )}
          </S.TotalTypeLabel>
        </div>
      </S.TotalMobileWrapper>
    </>
  );
};

export default Total;
